import axios from 'axios'
import { getHeader, termDueDateUrl } from './../config'

const state = {
  termDueList: []
}

const mutations = {
  SET_TERM_DUE_LIST (state, obj) {
    state.termDueList = obj
  }
}

const actions = {
  getTermDueList: ({ commit }) => {
    axios.get(termDueDateUrl, { headers: getHeader() })
      .then(response => {
        commit('SET_TERM_DUE_LIST', response.data.data)
      })
  }
}

export default {
  state, mutations, actions
}
